/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BalanceHistoryDataPoint } from './BalanceHistoryDataPoint';
import {
    BalanceHistoryDataPointFromJSON,
    BalanceHistoryDataPointFromJSONTyped,
    BalanceHistoryDataPointToJSON,
} from './BalanceHistoryDataPoint';

/**
 * 
 * @export
 * @interface BalanceHistoryResponse
 */
export interface BalanceHistoryResponse {
    /**
     * 
     * @type {Array<BalanceHistoryDataPoint>}
     * @memberof BalanceHistoryResponse
     */
    data: Array<BalanceHistoryDataPoint>;
}

/**
 * Check if a given object implements the BalanceHistoryResponse interface.
 */
export function instanceOfBalanceHistoryResponse(value: object): value is BalanceHistoryResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function BalanceHistoryResponseFromJSON(json: any): BalanceHistoryResponse {
    return BalanceHistoryResponseFromJSONTyped(json, false);
}

export function BalanceHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceHistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BalanceHistoryDataPointFromJSON)),
    };
}

export function BalanceHistoryResponseToJSON(value?: BalanceHistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(BalanceHistoryDataPointToJSON)),
    };
}

